"use client";

import { Text } from "@/components/ui/text";
import { ColorItem } from "@/components/common/color-item";
import { InputRadio } from "@/components/ui/input-radio";

import { useColorList, UseColorListProps } from "./use-color-list";

export type ColorListProps = UseColorListProps;

function ColorList(props: ColorListProps) {
  const {
    className,
    styles,
    data: { title, description, list, hexSwitchLabel, cmykSwitchLabel, id },
    sectionName,
    onChange,
    currentValue,
  } = useColorList(props);

  return (
    <section className={styles.base({ className })} data-section-name={sectionName}>
      <header className={styles.header()}>
        {title && (
          <Text tag="h3" size="titleMedium" className={styles.title()}>
            {title}
          </Text>
        )}
        {description && (
          <Text tag="p" size="bodyMedium" className={styles.description()}>
            {description}
          </Text>
        )}
      </header>

      <div className={styles.inputGroup()}>
        <InputRadio
          id={`color-mode-first-${id}`}
          label={hexSwitchLabel}
          name={`color-mode-${id}`}
          checked={currentValue === "hex"}
          onChange={onChange}
          value="hex"
        />
        <InputRadio
          id={`color-mode-second-${id}`}
          label={cmykSwitchLabel}
          name={`color-mode-${id}`}
          checked={currentValue === "cmyk"}
          onChange={onChange}
          value="cmyk"
        />
      </div>

      <div className={styles.list()}>
        {list.map((item, index) => (
          <ColorItem
            key={item.id}
            data={{ ...item, show: currentValue }}
            sectionName={sectionName}
            className={`sticky`}
            style={{
              top: `calc(5rem + 10px * ${index})`,
            }}
          />
        ))}
      </div>
    </section>
  );
}

export default ColorList;
